exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout-full-width {\n  width: 100%;\n  height: 100%;\n}\n.layout-full-width .content-wrap {\n  width: 100%;\n  height: 100%;\n}\n.layout-full-width .content-wrap .content {\n  width: 100%;\n  height: 100%;\n}\n.layout-full-width .content-wrap .content .context-item {\n  position: relative;\n  width: 100%;\n}\n.layout-full-width .content-wrap .content .context-item-fixed {\n  width: calc(100% - 280px);\n  margin-left: 280px;\n  height: 100%;\n  padding: 40px 40px 0 30px;\n}\n@media only screen and (max-width: 1100px) {\n.layout-full-width .content-wrap .content .context-item-fixed {\n    width: 100%;\n    margin-left: 0;\n}\n}", ""]);

// exports
